module.exports = __webpack_public_path__ + "img/t_home_back.d1a59bce.jpg";